// src/features/landing/application/useLandingContent.js
import { useMemo } from "react";
import { landingRepository } from "../infrastructure/landingStaticRepository";

/**
 * 랜딩 페이지에서 필요한 모든 도메인 데이터를 한 번에 가져오는 UseCase/Hook
 */
export function useLandingContent() {
    const heroSlides = useMemo(
        () => landingRepository.getHeroSlides(),
        []
    );
    const signatureItems = useMemo(
        () => landingRepository.getSignatureItems(),
        []
    );
    const serviceSteps = useMemo(
        () => landingRepository.getServiceSteps(),
        []
    );
    const valuePoints = useMemo(
        () => landingRepository.getValuePoints(),
        []
    );
    const treatmentCategories = useMemo(
        () => landingRepository.getTreatmentCategories(),
        []
    );
    const events = useMemo(
        () => landingRepository.getEvents(),
        []
    );

    return {
        heroSlides,
        signatureItems,
        serviceSteps,
        valuePoints,
        treatmentCategories,
        events,
    };
}
